import { Controller } from "@hotwired/stimulus"

// Drives the RSVP form: yes/no branch toggling, primary-name mirroring and
// the "other country" reveal.
export default class extends Controller {
  static targets = ["yesBranch", "noBranch", "submit", "otherCountry", "partnerInput", "kidsLabel"]
  static values = { sendYes: String, sendNo: String, kidsPlural: String, kidsSingle: String }

  connect() {
    this.sync()
  }

  sync() {
    const attending = this.element.querySelector('input[name="attending"]:checked')?.value

    this.toggleBranch(this.yesBranchTarget, attending === "yes")
    this.toggleBranch(this.noBranchTarget, attending === "no")
    this.submitTarget.disabled = !attending
    this.submitTarget.textContent = attending === "no" ? this.sendNoValue : this.sendYesValue

    const country = this.element.querySelector('input[name="household[departing_country]"]:checked')?.value
    this.otherCountryTarget.classList.toggle("hidden", country !== "other")
    const otherInput = this.otherCountryTarget.querySelector("input")
    otherInput.required = country === "other"
  }

  // "Bringing the kids?" is phrased for one or two people depending on
  // whether a partner is named (matters in Norwegian and Spanish)
  syncKidsLabel() {
    if (!this.hasKidsLabelTarget) return
    const hasPartner = this.hasPartnerInputTarget && this.partnerInputTarget.value.trim().length > 0
    this.kidsLabelTarget.textContent = hasPartner ? this.kidsPluralValue : this.kidsSingleValue
  }

  toggleBranch(branch, show) {
    branch.classList.toggle("hidden", !show)
    branch.disabled = !show
  }
}
